import { filter, first, Observable, of, ReplaySubject, switchMap, take, tap } from 'rxjs';
import { StartupState } from '../startup.state';
import { inject } from '@angular/core';
import { StartupStep } from '../startup-step';
import { CoordinatesModel, GEOLOCATION_TOKEN, GeolocationProvider, Log } from '@core';

export class SetDefaultFiltersStep extends StartupStep {
  private readonly geolocationProvider: GeolocationProvider = inject(GEOLOCATION_TOKEN);

  executeStep(state: StartupState): Observable<StartupState> {
    this.logger.log(Log.Startup, { message: 'SetDefaultFiltersStep START' });

    const coordinatesSubject: ReplaySubject<CoordinatesModel | null> = new ReplaySubject<CoordinatesModel | null>(1);
    state.coordinates$ = coordinatesSubject.asObservable();

    // Bez promptu - tylko coords$ dla backend-syncu (UpdateUserLocationStep). Filtry ustawia wejście na mapę/listę.
    state.authed$
      ?.pipe(
        filter(Boolean),
        first(),
        switchMap(() => this.geolocationProvider.getCoordinates()),
        take(1),
        tap((coordinates: CoordinatesModel | null) => {
          coordinatesSubject.next(coordinates);
          this.logger.log(Log.Startup, { message: 'SetDefaultFiltersStep COMPLETED', data: { coordinates } });
        })
      )
      .subscribe();

    return of(state);
  }
}
